import { ViSearch } from './visearch.js';
(function init(context) {
    if (typeof window !== 'undefined' && context && !context.viInit) {
        context.viInit = (context, clientName) => {
            const client = ViSearch();
            const stub = context[clientName];
            const q = (stub === null || stub === void 0 ? void 0 : stub.q) || [];
            q.forEach((command) => client.applyPrototypesCall(command));
            // replace the stub with the 'real' one after backcall
            context[clientName] = client;
            return client;
        };
    }
})(typeof self !== 'undefined' ? self : this);
export default ViSearch;
